export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    window.Am2AjaxFunctions.am2_remove_from_shortlist();
    window.Am2AjaxFunctions.am2_load_more_courses();
    window.Am2AjaxFunctions.am2_load_more_full_time_courses();
    window.Am2AjaxFunctions.am2_load_more_part_time_courses();
    window.Am2AjaxFunctions.am2_load_more_apprenticeship_courses();
    window.Am2AjaxFunctions.am2_load_more_university_level_courses();
    window.Am2AjaxFunctions.am2_search_filters_course_area();
    window.Am2AjaxFunctions.am2_search_filters_courses_archive();
    window.Am2AjaxFunctions.am2_get_shortlist_box();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js